import type { Tower, TowerSettings } from "types/towers.types"

export const isTowerHealthEnabled = (tower: Tower): boolean =>
  tower.settings?.features?.tower_health?.enabled === true

// Only the declared segments count. The pairs the worker publishes from the slots
// when none are declared are a fallback to keep the data, not segments to show.
export const getTowerSegments = (settings?: TowerSettings): string[] =>
  Object.keys(settings?.features?.tower_health?.segments ?? {})

export const hasTowerSegments = (tower: Tower): boolean =>
  isTowerHealthEnabled(tower) && getTowerSegments(tower.settings).length > 0
